import React from 'react';
import PropTypes from 'prop-types';
import { InputNumber } from 'antd';

// 只输入整数 Input
const InputNumberCom = (props) => {

  const [newProps, setProps] = React.useState(props);
  // const [inputValue, setInputValue] = React.useState('');

  React.useEffect(() => {
    if (props.integer === "true") {
      setProps({
        formatter: value => {
          if (!value) return 1;

          return String(value).replace(/([\d])?\..+/, '$1');
        },
        parser: value => {
          if (!value) return 1;

          return String(value).replace(/([\d])?\..+/, '$1')
        },
        ...props,
      })
    }
  }, [])

  return (
    <InputNumber
      {...newProps}
      value={props.value}
      onChange={props.onChange}
    />
  )
};

InputNumberCom.propTypes = {
  props: PropTypes.object
}

export default InputNumberCom;